import React from "react";
import {useEffect, useState} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {CenterBox} from "@pg-design/grid-module";
import {GalleryFillIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {head} from "@pg-mono/nodash";

import {getThumbnailLink} from "../utils/get_thumbnail_link";

interface IProps {
    property: {
        plan: string | null;
        plan_image_pages: {
            image_url: string | null;
            page: number;
        }[];
        external_plan_url: string | null;
        id: number;
    };
    offerName: string;
}

export const PropertyListPlanImage: React.FC<IProps> = (props) => {
    const {property} = props;
    const [isImageLoaded, setImageLoaded] = useState(false);

    const firstPlanPage = head(property.plan_image_pages);
    const externalPlanUrl = property?.external_plan_url;

    useEffect(() => {
        firstPlanPage && setImageLoaded(false);
    }, [firstPlanPage]);

    const blankIcon = (size: string) => {
        return (
            <div>
                <GalleryFillIcon size={size} />
            </div>
        );
    };

    const planPictureElement = (
        <picture css={planPicture}>
            {externalPlanUrl ? null : <source media="(min-width: 1024px)" srcSet={getThumbnailLink(firstPlanPage?.image_url, 1500)} />}
            <img
                css={[planImage]}
                src={externalPlanUrl || getThumbnailLink(firstPlanPage?.image_url, 980)}
                alt={props.offerName}
                onLoad={() => setTimeout(() => setImageLoaded(true), 50)}
            />
        </picture>
    );

    return (
        <div css={planImageHolder}>
            <>
                {!isImageLoaded && (
                    <div css={loaderWrapper}>
                        <CenterBox>
                            <Loader size="lg" />
                        </CenterBox>
                    </div>
                )}

                {firstPlanPage ? (
                    externalPlanUrl || property.plan ? (
                        <a css={planImageLink} href={(externalPlanUrl || property.plan) as string} target="_blank">
                            {planPictureElement}
                        </a>
                    ) : (
                        planPictureElement
                    )
                ) : (
                    <BlankImage>{blankIcon("18")}</BlankImage>
                )}
            </>
        </div>
    );
};

const BlankImage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => props.theme.colors.gray[300]};
    width: 100%;
    &:before {
        content: "";
        display: block;
        padding-top: 56.25%;
    }

    > div {
        > svg {
            fill: ${(props) => props.theme.colors.gray[700]};
        }
    }
`;

const planImageHolder = css`
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
`;

const planImageLink = css`
    overflow: hidden;
    display: flex;
    justify-content: center;
`;

const planPicture = css`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const planImage = css`
    object-fit: contain;
    display: block;
    max-width: 100%;
    max-height: 100%;
`;

const loaderWrapper = css`
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
`;
import React from "react";
import {useEffect, useState} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {CenterBox} from "@pg-design/grid-module";
import {GalleryFillIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {head} from "@pg-mono/nodash";

import {getThumbnailLink} from "../utils/get_thumbnail_link";

interface IProps {
    property: {
        plan: string | null;
        plan_image_pages: {
            image_url: string | null;
            page: number;
        }[];
        external_plan_url: string | null;
        id: number;
    };
    offerName: string;
}

export const PropertyListPlanImage: React.FC<IProps> = (props) => {
    const {property} = props;
    const [isImageLoaded, setImageLoaded] = useState(false);

    const firstPlanPage = head(property.plan_image_pages);
    const externalPlanUrl = property?.external_plan_url;

    useEffect(() => {
        firstPlanPage && setImageLoaded(false);
    }, [firstPlanPage]);

    const blankIcon = (size: string) => {
        return (
            <div>
                <GalleryFillIcon size={size} />
            </div>
        );
    };

    const planPictureElement = (
        <picture css={planPicture}>
            {externalPlanUrl ? null : <source media="(min-width: 1024px)" srcSet={getThumbnailLink(firstPlanPage?.image_url, 1500)} />}
            <img
                css={[planImage]}
                src={externalPlanUrl || getThumbnailLink(firstPlanPage?.image_url, 980)}
                alt={props.offerName}
                onLoad={() => setTimeout(() => setImageLoaded(true), 50)}
            />
        </picture>
    );

    return (
        <div css={planImageHolder}>
            <>
                {!isImageLoaded && (
                    <div css={loaderWrapper}>
                        <CenterBox>
                            <Loader size="lg" />
                        </CenterBox>
                    </div>
                )}

                {firstPlanPage ? (
                    externalPlanUrl || property.plan ? (
                        <a css={planImageLink} href={(externalPlanUrl || property.plan) as string} target="_blank">
                            {planPictureElement}
                        </a>
                    ) : (
                        planPictureElement
                    )
                ) : (
                    <BlankImage>{blankIcon("18")}</BlankImage>
                )}
            </>
        </div>
    );
};

const BlankImage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => props.theme.colors.gray[300]};
    width: 100%;
    &:before {
        content: "";
        display: block;
        padding-top: 56.25%;
    }

    > div {
        > svg {
            fill: ${(props) => props.theme.colors.gray[700]};
        }
    }
`;

const planImageHolder = css`
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
`;

const planImageLink = css`
    overflow: hidden;
    display: flex;
    justify-content: center;
`;

const planPicture = css`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const planImage = css`
    object-fit: contain;
    display: block;
    max-width: 100%;
    max-height: 100%;
`;

const loaderWrapper = css`
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
`;
